import { render, staticRenderFns } from "./CompareSlider.vue?vue&type=template&id=2fad7e8c&scoped=true&"
import script from "./CompareSlider.vue?vue&type=script&lang=js&"
export * from "./CompareSlider.vue?vue&type=script&lang=js&"
import style0 from "./CompareSlider.vue?vue&type=style&index=0&id=2fad7e8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fad7e8c",
  null
  
)

export default component.exports